/**
 * Bridge from Onyx action chips to the site’s custom SPA router in App.tsx.
 * HelpChatWidget must not import App; App listens for this event.
 */
export const ONYX_NAVIGATE_EVENT = 'komby:onyx-navigate';

const ALLOWED_PAGES = new Set([
  'home',
  'pricing',
  'contact',
  'compare',
  'help',
  'about',
  'checkout',
]);

export function requestOnyxPage(page: string): void {
  if (typeof window === 'undefined') return;
  const target = ALLOWED_PAGES.has(page) ? page : 'help';
  window.dispatchEvent(
    new CustomEvent(ONYX_NAVIGATE_EVENT, { detail: { page: target } })
  );
}
